import React, { useEffect, useState } from 'react';
import './header.css';
import { observer, inject } from 'mobx-react';
import Helper from '../../helper/helper';
import { Menu, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { applicationPaths, headerItems } from '../../helper/constants';
import SystemsList from '../SystemAccountStatus/SystemsList';

const Header = inject('RootStore')(observer(({ RootStore }) => {

    const [activeHeaderItem, setActiveHeaderItem] = useState(null);
    const [showSystemStatuses, setShowSystemStatuses] = useState(false);

    useEffect(() => {
        let activeItem = Helper.getActiveHeaderItem();
        setActiveHeaderItem(activeItem);
    }, [])


    const currentUser = RootStore.userStore.currentUser;

    const logoutClickHandler = () => RootStore.userStore.logout(null);

    const renderReportingButton = () => RootStore.userStore.shouldRenderReportinHeaderItem ?
        <Menu.Item
            as={Link}
            to={RootStore.userStore.isUserManager && (!RootStore.userStore.isUserSoxCompliance && !RootStore.userStore.isUserAdmin && !RootStore.userStore.isUserCiso) ? applicationPaths.allUserAccountsReport : applicationPaths.inactiveEmployeeAccounts}
            name='Reporting'
            active={activeHeaderItem === headerItems.reporting}
            onClick={() => setActiveHeaderItem(headerItems.reporting)}
        /> : <></>;

    const renderAdminPanel = () => RootStore.userStore.isUserAdmin ?
        <Menu.Item
            as={Link}
            to={applicationPaths.rolesAdminPanel}
            name='Admin Panel'
            active={activeHeaderItem === headerItems.rolesAdminPanel}
            onClick={() => setActiveHeaderItem(headerItems.rolesAdminPanel)}
        /> : <></>;

    const renderQaReviewPanel = () => RootStore.userStore.isUserManager || RootStore.userStore.isUserAdmin ?
        <Menu.Item
            as={Link}
            to={applicationPaths.qaReview}
            name='QAR Forms'
            active={activeHeaderItem === headerItems.qaReview}
            onClick={() => setActiveHeaderItem(headerItems.qaReview)}
        /> : <></>;

    const renderQarSystemsPanel = () => RootStore.userStore.isUserSoxCompliance || RootStore.userStore.isUserAdmin ?
        <Menu.Item
            as={Link}
            to={applicationPaths.soxSystems}
            name='QAR Admin'
            active={activeHeaderItem === headerItems.soxSystems}
            onClick={() => setActiveHeaderItem(headerItems.soxSystems)}
        /> : <></>;

    const renderRoleLifecycleButton = () => RootStore.userStore.shouldRenderRoleLifecycleHeaderItem ?
        <Menu.Item
            as={Link}
            to={applicationPaths.createRole}
            name='Role Lifecycle'
            active={activeHeaderItem === headerItems.roleLifecycle}
            onClick={() => setActiveHeaderItem(headerItems.roleLifecycle)}
        /> : <></>;

    const renderLogoutButton = () =>
        <Menu.Item
            name='Logout'
            onClick={() => logoutClickHandler()}
        />

    const renderLicenseAdminPanel = () => RootStore.userStore.isUserLicenseAdmin ?
        <Menu.Item
            as={Link}
            to={applicationPaths.licenseAdminPath}
            name='License Admin'
            active={activeHeaderItem === headerItems.licenseAdmin}
            onClick={() => setActiveHeaderItem(headerItems.licenseAdmin)}
        /> : <></>;

    const renderLicenseFormsPanel = () => RootStore.userStore.isUserLicenseAdmin || RootStore.userStore.isUserLicenseManager ?
        <Menu.Item
            as={Link}
            to={applicationPaths.licenseFormsPath}
            name='License Forms'
            active={activeHeaderItem === headerItems.licenseForms}
            onClick={() => setActiveHeaderItem(headerItems.licenseForms)}
        /> : <></>;

    const getCurrentSyncStatus = () => RootStore.accountStore.accountsSyncStatus ? !RootStore.accountStore.accountsSyncStatus.some(x => !x.isHealthy) : false;

    const currentSystemSyncStatus = () => {
        let isSyncStatusHealthy = getCurrentSyncStatus();

        return RootStore.userStore.isUserSoxCompliance ? <Menu.Item
            name={"syncStatus"}
            className='view-info-label statusClick'
            active={activeHeaderItem === headerItems.status}
            onClick={() => setShowSystemStatuses(!showSystemStatuses)}>
             System Sync Status: {isSyncStatusHealthy ? <span className="circle-color-healthy statusClick">&nbsp;Healthy</span> : <span className="circle-color-unhealthy statusClick">&nbsp;Unhealthy</span>}
        </Menu.Item> : <></>
    }

    const getLogoHref = () => currentUser === undefined ? "login" : "/" ;

    return (
        
        <Segment className='segment'>
            <Menu pointing className="ui-pointing-menu">
                <Menu.Item className="navbar-header">
                    <img src={"..\\..\\favicon.png"}/> &nbsp; &nbsp;  
                    <a className="navbar-brand" href={getLogoHref()}>RBAC-Manhattan</a>
                </Menu.Item>
                {RootStore.userStore.isUserPresent ? <>
                    {renderReportingButton()}
                    {/* {renderRoleLifecycleButton()} */}
                    {/* {renderAdminPanel()} */}
                    {renderQarSystemsPanel()}
                    {renderQaReviewPanel()}
                    {renderLicenseAdminPanel()}
                    {renderLicenseFormsPanel()}
                    <Menu.Menu position="right">
                        {currentSystemSyncStatus()}
                        {renderLogoutButton()}
                    </Menu.Menu>
                </> : <></>}
            </Menu>
            <SystemsList
                systemsAccounts={RootStore.accountStore.accountsSyncStatus}
                show={showSystemStatuses}
                onClose={() => setShowSystemStatuses(false)}
            />
        </Segment>
    )
}));

export default Header;
